/**
 * EastSupplier footer — animated sky & clouds (云端)
 */
(function () {
  'use strict';

  function initFooterClouds(footer) {
    if (footer.dataset.esCanvasInit === '1') return;
    footer.dataset.esCanvasInit = '1';

    var canvas = footer.querySelector('[data-footer-cloud-canvas]');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0;
    var h = 0;
    var layState = { lastW: 0, lastH: 0 };
    var clouds = [];
    var rafId = null;
    var running = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function rand(a, b) {
      return a + Math.random() * (b - a);
    }

    function buildClouds() {
      clouds = [];
      var count = Math.max(6, Math.floor(w / 140));
      for (var i = 0; i < count; i++) {
        var layer = i % 3;
        clouds.push({
          x: rand(0, w),
          y: rand(h * 0.05, h * 0.75),
          scale: rand(0.45, 1.15) * (layer === 0 ? 0.75 : layer === 1 ? 1 : 1.25),
          speed: (layer === 0 ? 0.04 : layer === 1 ? 0.07 : 0.1) * (Math.random() > 0.5 ? 1 : -1),
          opacity: rand(0.35, 0.72) * (layer === 2 ? 1 : 0.85),
          bob: rand(0, Math.PI * 2),
          bobSp: rand(0.3, 0.7)
        });
      }
    }

    function resize() {
      var L = window.EastSupplierCanvasLayout;
      if (L) {
        var m = L.measure(canvas, footer, { minW: 300, minH: 200, state: layState });
        w = m.w;
        h = m.h;
        dpr = m.dpr;
        L.applyBitmap(canvas, ctx, w, h, dpr);
      } else {
        var rect = (canvas.parentElement || footer).getBoundingClientRect();
        w = Math.max(300, rect.width);
        h = Math.max(200, rect.height);
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.floor(w * dpr);
        canvas.height = Math.floor(h * dpr);
        if (canvas.style) {
          canvas.style.width = '';
          canvas.style.height = '';
        }
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      buildClouds();
    }

    function drawSky() {
      var g = ctx.createLinearGradient(0, 0, 0, h);
      g.addColorStop(0, '#c5e3f7');
      g.addColorStop(0.35, '#dceefb');
      g.addColorStop(0.7, '#eef6fc');
      g.addColorStop(1, '#f7f4f2');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
    }

    function drawCloudPuff(x, y, s, alpha) {
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.fillStyle = '#ffffff';
      function puff(px, py, r) {
        ctx.beginPath();
        ctx.arc(px, py, r, 0, Math.PI * 2);
        ctx.fill();
      }
      puff(x, y, s * 0.52);
      puff(x - s * 0.48, y + s * 0.06, s * 0.4);
      puff(x + s * 0.44, y + s * 0.04, s * 0.44);
      puff(x + s * 0.12, y - s * 0.22, s * 0.36);
      puff(x - s * 0.15, y - s * 0.12, s * 0.32);
      ctx.restore();
    }

    function drawCloud(c, time) {
      var bob = reducedMotion ? 0 : Math.sin(time * c.bobSp + c.bob) * 4;
      var base = 32 * c.scale;
      drawCloudPuff(c.x, c.y + bob, base, c.opacity);
      drawCloudPuff(c.x + base * 0.35, c.y + bob + base * 0.08, base * 0.85, c.opacity * 0.85);
    }

    function frame(ts) {
      if (!running) return;
      var expectedW = Math.max(1, Math.floor(w * dpr));
      if (canvas.width < expectedW * 0.5 || canvas.height < Math.max(1, Math.floor(h * dpr)) * 0.5) {
        resize();
      }
      var time = ts * 0.001;

      if (!reducedMotion) {
        clouds.forEach(function (c) {
          c.x += c.speed * 0.35;
          if (c.x > w + 120) c.x = -120;
          if (c.x < -120) c.x = w + 120;
        });
      }

      ctx.clearRect(0, 0, w, h);
      drawSky();

      var sorted = clouds.slice().sort(function (a, b) {
        return a.scale - b.scale;
      });
      sorted.forEach(function (c) {
        drawCloud(c, time);
      });

      rafId = requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      resize();
      running = true;
      rafId = requestAnimationFrame(frame);
    }

    function stop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
    }

    resize();
    window.addEventListener('resize', resize);

    if (typeof ResizeObserver !== 'undefined' && canvas.parentElement) {
      new ResizeObserver(function () {
        resize();
      }).observe(canvas.parentElement);
    }

    requestAnimationFrame(function () {
      resize();
    });

    start();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            resize();
            start();
          } else stop();
        });
      }, { threshold: 0 }).observe(footer);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else {
        resize();
        var fr = footer.getBoundingClientRect();
        if (fr.bottom > 0 && fr.top < window.innerHeight) start();
      }
    });

    window.addEventListener('pageshow', function () {
      resize();
      start();
    });
  }

  function boot() {
    document.querySelectorAll('[data-footer-clouds]').forEach(initFooterClouds);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
